/**
 * Tema claro/escuro/automático.
 *
 * Uma preferência de navegador, não de conta — cada dispositivo guarda a
 * sua. "Automático" não grava nada e não estampa `data-theme`: quem decide
 * nesse caso é só a media query em app/globals.css, como sempre foi.
 *
 * Compartilhado entre o script inline em app/layout.tsx (roda antes da
 * hidratação, pra não piscar no tema errado) e o alternador em
 * Configuracoes.tsx — os dois precisam concordar na mesma chave.
 */

export const CHAVE_TEMA = "lummichat_tema";

export type Tema = "claro" | "escuro";

export function lerTemaSalvo(): Tema | null {
  const v = localStorage.getItem(CHAVE_TEMA);
  return v === "claro" || v === "escuro" ? v : null;
}

export function aplicarTema(tema: Tema | null) {
  if (tema) {
    localStorage.setItem(CHAVE_TEMA, tema);
    if (typeof document !== "undefined") {
      document.cookie = `${CHAVE_TEMA}=${tema}; path=/; max-age=31536000; SameSite=Lax`;
      document.documentElement.dataset.theme = tema === "claro" ? "light" : "dark";
      document.documentElement.classList.toggle("dark", tema === "escuro");
    }
  } else {
    localStorage.removeItem(CHAVE_TEMA);
    if (typeof document !== "undefined") {
      document.cookie = `${CHAVE_TEMA}=; path=/; max-age=0; SameSite=Lax`;
      delete document.documentElement.dataset.theme;
      const prefereEscuro = window.matchMedia("(prefers-color-scheme: dark)").matches;
      document.documentElement.classList.toggle("dark", prefereEscuro);
    }
  }
}
